// The element ID format for the room domain: build, validate, and parse
import { TYPE_IDENTIFIERS } from '../types';
/**
 * Element ID shape: [roomCode][typeIdentifier][paddedCounter]
 * Room codes are always six digits (backend generateCode), and the counter is
 * padded to three, so a valid element ID is exactly ten characters. Anchoring
 * the whole shape keeps ULIDs — which share the T/P/A/V/S/M/W/E letters — from
 * ever looking like an element ID.
 */
const elementIdPattern = new RegExp(`^\\d{6}[${Object.values(TYPE_IDENTIFIERS).join('')}]\\d{3}$`);
/**
 * Generates a sequential ID for domain elements
 * Format: [roomCode][typeIdentifier][paddedCounter]
 * Example: "123456T001", "123456P001", "123456I001"
 */
export function generateElementId(roomCode, elementType, counter) {
    const typeIdentifier = TYPE_IDENTIFIERS[elementType];
    const paddedCounter = counter.toString().padStart(3, '0');
    return `${roomCode}${typeIdentifier}${paddedCounter}`;
}
/**
 * Validates element ID format: [roomCode][typeIdentifier][3digits]
 * Example valid ID: "123456T001"
 */
export function isValidElementId(id) {
    return elementIdPattern.test(id);
}
/**
 * Parses an element ID into its components, or null if it is not one
 * Example: "123456T001" -> { roomCode: "123456", elementType: "TURN", counter: 1 }
 */
export function parseElementId(id) {
    if (!isValidElementId(id))
        return null;
    const typeIdentifier = id.slice(-4, -3);
    const elementType = Object.entries(TYPE_IDENTIFIERS).find(([_, value]) => value === typeIdentifier)?.[0];
    return {
        roomCode: id.slice(0, -4),
        elementType,
        counter: parseInt(id.slice(-3), 10),
    };
}
//# sourceMappingURL=elementId.js.map